module.exports = __webpack_public_path__ + "img/huoweizhuanyi-h.80a550ef.svg";